import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { subscribe } from 'alfa';
import { Alert, Button, Form, Input, Typography, message } from 'antd';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import Link from '../../components/link';
import ManagerRepo from '../../repository/manager';
import URL from '../../helpers/url';

const { Title } = Typography;

const ManagerNew = withTranslation()(({ business, form: { getFieldDecorator, validateFields }, history, t, ...props }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    await validateFields(async (err, { email }) => {
      if (err) {
        setLoading(false);
        return;
      }
      try {
        await ManagerRepo.create(business, { email });
        message.success(t('success.creating_manager'));
        history.push(URL('/managers', props));
      } catch (manageRepoCreateError) {
        message.error(t('error.creating_manager'));
        console.error('ERROR: ManagerNew: onSubmit()', manageRepoCreateError); // eslint-disable-line no-console
        setError((manageRepoCreateError.response) ? manageRepoCreateError.response.data.message : manageRepoCreateError.message);
        setLoading(false);
      }
    });
  };

  const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 14 },
  };

  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 12,
        offset: 6,
      },
    },
  };

  return (
    <>
      <Title level={3}>{t('create_manager')}</Title>
      <Form {...formItemLayout} onSubmit={onSubmit}>
        {(error === null) ? '' : (
          <Alert
            message={t('error.creating_manager')}
            description={error}
            type="error"
            showIcon
            banner
            style={{ margin: '30px -20px 30px -20px' }}
          />
        )}

        <Form.Item label={t('email')}>
          {getFieldDecorator('email', {
            rules: [{
              required: true,
              message: t('manager.required.email'),
            }, {
              type: 'email',
              message: t('manager.required.email'),
            }],
          })(
            <Input name="email" />,
          )}
        </Form.Item>
        <Form.Item {...tailFormItemLayout}>
          <Button loading={loading} type="primary" htmlType="submit">{t('create')}</Button>&nbsp;
          <Link to="/managers" className="ant-btn">{t('cancel')}</Link>
        </Form.Item>
      </Form>
    </>
  );
});

ManagerNew.propTypes = {
  business: PropTypes.object,
  form: PropTypes.shape({
    validateFields: PropTypes.func,
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  t: PropTypes.func,
};

export default withRouter(subscribe(Form.create({ name: 'manager-new' })(ManagerNew), ['business']));
